import React from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import { COLORS } from '../../utils/constants';

function getStackedBarChartItem(name, value, color, additionalProps = {}) {
  return {
    name,
    value,
    color,
    label: (
      <>
        {name}: <CurrencyFormat value={value} text />
      </>
    ),
    ...additionalProps,
  };
}

export function agreedBar(agreedBudget) {
  return getStackedBarChartItem('Agreed', agreedBudget, COLORS.SUCCESS);
}

export function plannedBar(plannedBudget) {
  return getStackedBarChartItem('Planned', plannedBudget, COLORS.WARNING);
}

export function openBar(openBudget) {
  return getStackedBarChartItem('Open', openBudget, COLORS.INFO);
}

export function overspentBar(overspentBudget) {
  return getStackedBarChartItem('Overspent', overspentBudget, COLORS.DANGER);
}
